import { ValueFormatterParams } from 'ag-grid-community';

export const percentageFormatter = (params: ValueFormatterParams) => {
    if (!params.value) return '';
    return (params.value * 100).toFixed(2) + '%';
};
